import {useNavigate} from "react-router-dom";
import {adatkezelesDocUrl, aszfDocUrl} from "../../utils/Constants";

export function Footer(){

    const navigate = useNavigate();
    return (
        <footer className="p-0 footer-light position-relative">
            <div className="container position-relative">
                <div className="row justify-content-center pt-5 sm-pt-40px">
                    <div
                        className="col-6 col-xl-3 col-lg-12 col-sm-6 last-paragraph-no-margin text-xl-start text-lg-center order-sm-1 lg-mb-50px sm-mb-30px">
                        <a href="/" className="footer-logo mb-15px d-inline-block"> <img
                            src="/benefitshare/img/demo-it-business-logo-black.png"
                            data-at2x="/benefitshare/img/demo-it-business-logo-black@2x.png" alt=""/> </a>
                        <p className="lh-28 w-90 xl-w-100 mx-lg-auto mx-xl-0">For Sharing ideas, shaping success.</p>
                        <div className="elements-social social-icon-style-02 mt-15px">
                            <ul className="medium-icon dark">
                                <li className="my-0"><a className="facebook" href="https://www.facebook.com/beneFitSHAREconference/"
                                                        target="_blank"><i className="fa-brands fa-facebook-f"></i></a>
                                </li>
                                <li className="my-0"><a className="instagram" href="https://www.instagram.com/benefitshare/"
                                                        target="_blank"><i className="fa-brands fa-instagram"></i></a>
                                </li>
                                <li className="my-0"><a className="linkedin" href="https://www.linkedin.com/company/benefit-share/"
                                                        target="_blank"><i className="fa-brands fa-linkedin"></i></a>
                                </li>
                                <li className="my-0"><a className="youtube" href="http://www.youtube.com"
                                                        target="_blank"><i className="fa-brands fa-youtube"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-6 col-xl-2 col-lg-3 col-sm-4 xs-mb-30px order-sm-3 order-lg-2"><span
                        className="fw-600 d-block text-dark-gray mb-5px">Rólunk</span>
                        <ul>
                            <li><a href={'/#miazabenefitshare'}>Mi az a BeneFit SHARE?</a>
                            </li>
                            <li><a href={'/#mitolmasabenefitshare'}>Mitől más a BeneFit SHARE?</a>
                            </li>
                            <li><a href={'/#sponsors'}>Partnerek</a>
                            </li>
                            <li><a href="/kapcsolat">Kapcsolat</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-6 col-xl-2 col-lg-3 col-md-5 col-sm-4 xs-mb-30px order-sm-4 order-lg-3"><span
                        className="fw-600 d-block text-dark-gray mb-5px">A rendezvényről</span>
                        <ul>
                            <li><a href="/programok">Programok</a>
                            </li>
                            <li><a href="/eloadok">Előadók</a>
                            </li>
                            <li><a href="/kiallitok">Kiállítók</a>
                            </li>
                            <li><a href="/jegyek">Jegyvásárlás</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-6 col-xl-2 col-lg-3 col-md-3 col-sm-4 xs-mb-30px order-sm-5 order-lg-4"><span
                        className="fw-600 d-block text-dark-gray mb-5px">Kapcsolat</span>
                        <span>Email</span> <a href="mailto:help@domain.com"
                                               className="text-dark-gray fw-600">info@benefitprize.hu</a>
                    </div>
                </div>
                <div className="row justify-content-center align-items-center pt-7">
                    <div className="col-12">
                        <div className="divider-style-03 divider-style-03-01 border-color-extra-medium-gray"></div>
                    </div>
                    <div
                        className="col-lg-5 pt-20px pb-20px md-pt-0 order-2 order-lg-1 text-center text-lg-start last-paragraph-no-margin fs-14">
                        <p>© 2025 BeneFit SHARE</p>
                    </div>
                    <div
                        className="col-lg-7 pt-20px pb-20px md-pt-25px md-pb-5px order-1 order-lg-2 text-center text-lg-end fs-14">
                        <ul className="footer-navbar sm-lh-normal">
                            <li><a href="/impresszum" className="nav-link">Impresszum</a>
                            </li>
                            <li><a target="_blank" href={adatkezelesDocUrl} className="nav-link">Adatkezelési tájékoztató</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}